// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KAW_S","label":"styles_label__3dliT"};